import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsGravComponent } from './simple-icons-grav.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsGravComponent ],
    exports:      [ SimpleIconsGravComponent ],
    bootstrap:    []
})
export class SimpleIconsGravModule {}
